import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { IMediaUploaderService, SaveMediaUploadRequestModel } from ".";

class MediaUploaderServiceClass extends GLServiceBase<any, any> implements IMediaUploaderService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/media" };

	SaveMediaUpload(model: SaveMediaUploadRequestModel, previousMediaId?: string): Promise<any> {
		var query = `?previousMediaId=${previousMediaId}`;
		return this.create("SaveMediaUpload" + query, model, undefined);
	}

	HasPageMedia(params: { mediaId: string }): Promise<boolean> {
		return this.get("HasPageMedia", params);
	}
}

export const MediaUploadService: IMediaUploaderService = new MediaUploaderServiceClass();
